import API from 'services/API';

export default function getPropertyObjectTypes() {
  return API.request({
    method: 'GET',
    url: '/property/types',
    mapper: function (data) {
      return data.map(function ({ id, name }) {
        return {
          id,
          title: name,
        };
      });
    },
  });
}
